
export default function Projects() {
  const projectExamples = [
    {
      title: 'Digitalización Productiva',
      description: 'Una empresa familiar moderniza su proceso de producción con tecnología 4.0',
      impact: 'Incremento del 40% en eficiencia',
      image: 'https://readdy.ai/api/search-image?query=Modern%20industrial%20facility%20in%20rural%20setting%20with%20digital%20technology%20integration%2C%20automated%20production%20line%2C%20clean%20and%20efficient%20workspace%2C%20representing%20digital%20transformation%20in%20rural%20manufacturing%2C%20professional%20photography%2C%20bright%20lighting&width=400&height=300&seq=project1-territorio360&orientation=landscape'
    },
    {
      title: 'Red Cultural Digital',
      description: 'Un municipio crea una plataforma para conectar su patrimonio cultural',
      impact: 'Aumento del 60% en turismo cultural',
      image: 'https://readdy.ai/api/search-image?query=Historic%20rural%20town%20with%20digital%20information%20displays%2C%20tourists%20using%20tablets%20and%20smartphones%20to%20explore%20cultural%20heritage%2C%20traditional%20architecture%20enhanced%20with%20modern%20technology%2C%20representing%20digital%20cultural%20innovation&width=400&height=300&seq=project2-territorio360&orientation=landscape'
    },
    {
      title: 'Sostenibilidad Energética',
      description: 'Una cooperativa implementa un sistema de energía renovable comunitario',
      impact: 'Reducción del 70% en costes energéticos',
      image: 'https://readdy.ai/api/search-image?query=Rural%20cooperative%20with%20solar%20panels%20and%20wind%20turbines%2C%20sustainable%20energy%20infrastructure%20in%20countryside%20setting%2C%20community%20members%20working%20together%2C%20representing%20renewable%20energy%20innovation%20in%20rural%20areas&width=400&height=300&seq=project3-territorio360&orientation=landscape'
    }
  ];

  return (
    <section id="proyectos" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            Innovar con raíces
          </h2>
          
          <div className="max-w-4xl mx-auto space-y-6 text-lg text-gray-700 leading-relaxed">
            <p>
              Cada proyecto que acompañamos cuenta una historia de transformación: una empresa que digitaliza su proceso productivo, un municipio que crea una red cultural digital, una cooperativa que apuesta por la sostenibilidad energética.
            </p>
            
            <blockquote className="text-xl italic text-gray-800 bg-gray-50 p-8 rounded-lg">
              Son pequeñas semillas que, juntas, están cambiando el paisaje de la innovación rural.
            </blockquote>
            
            <p>
              Queremos que <strong className="text-teal-600">Territorio360</strong> sea el escaparate donde esas historias inspiren a otras a comenzar su propio camino.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {projectExamples.map((project, index) => (
            <div key={index} className="bg-gray-50 rounded-xl overflow-hidden hover:shadow-lg transition-shadow">
              <img 
                src={project.image}
                alt={project.title}
                className="w-full h-48 object-cover"
              />
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {project.title}
                </h3>
                <p className="text-gray-700 mb-4 leading-relaxed">
                  {project.description}
                </p>
                <div className="bg-teal-100 text-teal-800 px-3 py-2 rounded-lg text-sm font-semibold">
                  {project.impact}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <div className="bg-teal-50 rounded-xl p-8 max-w-4xl mx-auto">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              ¿Tienes un proyecto en mente?
            </h3>
            <p className="text-lg text-gray-700 mb-6">
              Cada gran transformación comienza con una idea. Cuéntanos la tuya y exploremos juntos las posibilidades.
            </p>
            <button className="bg-teal-600 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-teal-700 transition-colors cursor-pointer whitespace-nowrap">
              Comparte tu idea
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
